<!-- Only needed here since this is not a real dialog -->
<div class="k-dialog-wrapper">
  <div class="k-window k-h-full">
    <div class="k-window-content k-d-flex k-flex-column">
      <header class="k-px-10 k-pt-4 k-pb-6 k-d-flex k-align-items-center">
        @defer (when finishedLoading()) {
          <form [formGroup]="todoTitleForm()">
            <kendo-textbox
              showErrorIcon="initial"
              id="todoEntryTitle"
              [formControlName]="formControlNames.Title"
              [style.width.px]="200"
              appAfterValueChanged
            >
            </kendo-textbox>
          </form>

          <div class="k-ml-auto">
            <span class="k-align-self-center">
              <a
                #assignProjectPopupAnchor
                shivePopup
                [popupAnchor]="assignProjectPopupAnchor"
                [content]="assignProjectPopupContent"
                [popupSettings]="popupSettings()"
                role="button"
              >
                <fa-icon class="icon turquoise k-mr-3" [icon]="faProjector"></fa-icon>
              </a>

              <ng-template #assignProjectPopupContent>
                <app-todo-assign-to-project (closePopup)="onAssignProjectPopupClose($event)" />
              </ng-template>
            </span>

            <fa-icon
              role="button"
              class="icon turquoise k-mr-3"
              [icon]="todoEntryModel().completed ? faCheck : faClock"
              (click)="propChanged([!todoEntryModel().completed, formControlNames.Completed])"
            ></fa-icon>

            <span #filePopupAnchor class="k-align-self-center">
              <a
                shivePopup
                role="button"
                [popupSettings]="popupSettings()"
                [popupAnchor]="filePopupAnchor"
                [content]="popupContent"
              >
                <fa-icon class="icon turquoise" [icon]="faPaperclip"></fa-icon>
              </a>
            </span>
          </div>
        }
      </header>

      <div class="dialog-content k-px-10 k-flex-1">
        @defer (when finishedLoading()) {
          <form class="k-form k-h-full k-d-flex k-flex-column" [formGroup]="todoEntryForm()">
            <div id="project-start-end" class="k-d-grid k-align-items-center">
              <kendo-label [for]="startsAt" text="Laufzeit"></kendo-label>
              <kendo-formfield orientation="horizontal" class="!k-d-block">
                <kendo-datepicker
                  [id]="formControlNames.StartsAt"
                  [formControlName]="formControlNames.StartsAt"
                  #startsAt
                  (valueChange)="startDateChanged($event)"
                >
                </kendo-datepicker>
              </kendo-formfield>

              <span class="k-mx-2.5 k-label">bis</span>

              <kendo-formfield orientation="horizontal" class="!k-d-block">
                <kendo-datepicker
                  [id]="formControlNames.EndsAt"
                  [formControlName]="formControlNames.EndsAt"
                >
                </kendo-datepicker>
              </kendo-formfield>
            </div>

            <div class="k-d-flex">
              <kendo-formfield orientation="horizontal">
                <kendo-label text="Farbe" [for]="todoColor"></kendo-label>
                <kendo-colorpicker
                  [format]="'hex'"
                  class="k-w-24"
                  [paletteSettings]="{ palette: defaultPalette }"
                  [id]="formControlNames.TodoColor"
                  [formControlName]="formControlNames.TodoColor"
                  [views]="['palette']"
                  [clearButton]="false"
                  #todoColor
                >
                </kendo-colorpicker>
              </kendo-formfield>

              <kendo-formfield orientation="horizontal" class="k-ml-5 k-flex-1">
                <kendo-label [for]="priority" text="Priorität"></kendo-label>
                <kendo-dropdownlist
                  textField="text"
                  valueField="value"
                  [valuePrimitive]="true"
                  [formControlName]="formControlNames.Priority"
                  #priority
                  [data]="priorityOptions"
                >
                </kendo-dropdownlist>
              </kendo-formfield>
            </div>

            <kendo-editor
              class="text-editor k-flex-1 k-mb-6"
              #editor
              [formControlName]="formControlNames.Editor"
              [iframeCss]="iframeStyles"
            >
              <kendo-toolbar>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                <kendo-toolbar-colorpicker
                  kendoEditorBackColor
                  [paletteSettings]="{ palette: defaultPalette }"
                ></kendo-toolbar-colorpicker>
              </kendo-toolbar>
            </kendo-editor>
          </form>
        } @placeholder {
          <div class="k-px-10 k-py-6">Loading…</div>
        }
      </div>
    </div>

    <footer #dialogFooter class="k-window-footer k-d-flex k-justify-content-between k-mt-auto">
      <div>
        <button
          kendoButton
          size="large"
          themeColor="secondary"
          class="k-mr-4 !k-pr-4"
          (click)="close()"
        >
          <span class="custom-symbol close k-mr-3"></span>
          Schließen
        </button>
        <button kendoButton themeColor="error" class="!k-pr-4" size="large" (click)="delete()">
          <span class="custom-symbol delete k-mr-3 red"></span>
          Löschen
        </button>
      </div>
      <div>
        <button kendoButton themeColor="base" class="!k-pr-4" size="large" (click)="update()">
          <span class="custom-symbol save k-mr-3"></span>
          Aktualisieren
        </button>
      </div>
    </footer>
  </div>
</div>
